import type { ComponentType } from 'react';
import { MasterDataReadOnly } from '../../components/master-data.tsx';

/**
 * Um cadastro corporativo aberto no FP&A: a mesma tela de Dados Mestres, só para consulta, com o
 * atalho "Gerenciar em Sistema" para quem pode mantê-lo (ADR 0032, seção 12). Desde a decisão M1
 * (ADR 0049), só o Plano de contas gerencial é aberto assim, até a decisão D1.
 */
export function fpaMasterData(Page: ComponentType, manageTo: string) {
  return function FpaMasterDataPage() {
    return (
      <MasterDataReadOnly manageTo={manageTo}>
        <Page />
      </MasterDataReadOnly>
    );
  };
}
